import { render, staticRenderFns } from "./bold.vue?vue&type=template&id=177dbe64&scoped=true&"
import script from "./bold.vue?vue&type=script&lang=js&"
export * from "./bold.vue?vue&type=script&lang=js&"
import style0 from "./bold.vue?vue&type=style&index=0&id=177dbe64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177dbe64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
